import React, { useContext, useEffect, useState } from "react";
import errorIcon from "../../images/errorRedIcon.png";
import successIcon from "../../images/successGreenIcon.png";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { AppContext } from "../../contexts/AppContext";
import { UrlContext } from "../../contexts/UrlContext";
import { useNavigate } from "react-router-dom";

export default function ProjectDetailsStatus({
  project_status,
  project_id,
  setProjectLost,
  projectStatus,
  setProjectStatus,
}) {
  const [selectProjectStatusStyle, setSelectProjectStatusStyle] = useState({
    background: "red",
    color: "white",
  });
  const { API_URL } = useContext(UrlContext);
  const [returnSuccess, setReturnSuccess] = useState(false);
  const [returnError, setReturnError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { projects, setProjects } = useContext(AppContext);
  const navigate = useNavigate();
  useEffect(() => {
    if (project_status) {
      setProjectStatus(project_status);
    }
  }, [project_status]);

  useEffect(() => {
    if (projectStatus === "Project Closed (Won)") {
      setSelectProjectStatusStyle({
        background: "rgb(198, 224, 180)",
        color: "black",
      });
    } else if (projectStatus === "Project Closed (Lost)") {
      setSelectProjectStatusStyle({
        background: "rgb(250, 218, 196)",
        color: "black",
      });
    } else if (projectStatus === "Not Started") {
      setSelectProjectStatusStyle({ background: "red", color: "white" });
    } else if (projectStatus === "Profiling") {
      setSelectProjectStatusStyle({
        background: "rgb(255, 192, 0)",
        color: "black",
      });
    } else if (projectStatus === "Waiting for input") {
      setSelectProjectStatusStyle({
        background: "rgb(0, 176, 80)",
        color: "white",
      });
    } else if (projectStatus === "Contracting") {
      setSelectProjectStatusStyle({
        background: "rgb(255, 192, 0)",
        color: "black",
      });
    }
  }, [projectStatus]);

  const handleUpdateStatus = (value) => {
    if (value === "Project Closed (Won)") {
      navigate(`/app/ProjectInformation/${project_id}/0`);
      return;
    } else if (value === "Contracting") {
      navigate(`/app/ProjectInformation/${project_id}/1`);
      return;
    } else if (value === "Project Closed (Lost)") {
      setProjectLost(true);
    } else {
      setReturnError(false);
      setLoading(true);
      setProjectStatus(value);
      const selectedProjectStatus = value;
      const projectID = project_id;
      const selectedProject = projects.filter(
        (proj) => proj.id === projectID
      )[0];
      const modifiedProject = {
        ...selectedProject,
        status: selectedProjectStatus,
      };
      const projectData = {
        selectedProjectStatus,
        projectID,
      };
      const ephToken = localStorage.getItem("eph-token");
      const token = JSON.parse(ephToken).value;

      fetch(`${API_URL}update-project-status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify({ data: projectData, reason: "" }),
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          if (data.status === "success") {
            setReturnSuccess(true);
            setProjects(
              projects.map((project) =>
                project.id === modifiedProject.id ? modifiedProject : project
              )
            );
            setTimeout(() => {
              setReturnSuccess(false);
            }, 1500);
          } else {
            setReturnError(true);
          }
        })
        .catch((err) => {
          setLoading(false);
          setReturnError(true);
          Swal.fire({
            icon: "error",
            title: "Database connection error!",
            text: "Please logout and try again.",
            confirmButtonText: "OK",
          });
          console.log(err);
        });
    }
  };

  return (
    <>
      <select
        style={{
          ...selectProjectStatusStyle, 
          width: "150px", 
          height: "32px",
          borderRadius: "5px", 
          border: "none", 
          cursor: "pointer", 
          outline: "none", 
          textAlign: "center", 
          marginLeft: "2px",
          border: "1px solid #ccc",
          appearance: "none"
        }}
        onChange={(e) => handleUpdateStatus(e.target.value)}
        value={projectStatus}
      >
        <option value="Not Started">Not Started</option>
        <option value="Profiling">Profiling</option>
        <option value="Waiting for input">Waiting For Input</option>
        <option value="Contracting">Contracting</option>
        <option value="Project Closed (Won)">Project Closed (Won)</option>
        <option value="Project Closed (Lost)">Project Closed (Lost)</option>
      </select>
      {loading && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", left: "138px" }}
          src={LoadingIcon}
          alt="loading"
          title="Loading..."
        />
      )}
      {returnSuccess && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", left: "138px" }}
          src={successIcon}
          alt="success"
          title="Success"
        />
      )}
      {returnError && (
        <img
          className="return-msg-icon"
          style={{ top: "5px", left: "138px" }}
          src={errorIcon}
          alt="error"
          title="Error! Please reload"
        />
      )}
    </>
  );
}